import React from "react";
import { Tooltip } from "@material-ui/core";
import usePixModalStyles from "../PixPaymentModal.styles";
import { useCopyToClipboard } from "../hooks/useCopyToClipboard";
import { PixValueSectionProps } from "../types";

const formatAmount = (value: number) => {
  const parts = value
    .toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .split(",");
  return { integer: parts[0], decimals: parts[1] };
};

const PixValueSection: React.FC<PixValueSectionProps> = ({
  amount,
  pixCopiaECola,
  isComplement = false,
}) => {
  const classes = usePixModalStyles();
  const { integer, decimals } = formatAmount(amount);
  const { copied, copy } = useCopyToClipboard();

  return (
    <div className={classes.valueSection}>
      <div className={classes.valueLabel}>Valor a pagar</div>
      <div className={classes.valueAmount}>
        <span className={classes.valueCurrency}>R$</span> {integer}
        <span className={classes.valueDecimals}>,{decimals}</span>
      </div>
      <div className={classes.valueSubtitle}>
        {isComplement
          ? "Pix complementar · ajuste de valor do pedido"
          : "Pagamento integral do pedido"}
      </div>

      <div className={classes.copyRow}>
        <span className={classes.copyField} title={pixCopiaECola}>
          {pixCopiaECola}
        </span>
        <Tooltip title={copied ? "Copiado!" : "Copiar código Pix"}>
          <button
            className={classes.copyButton}
            onClick={() => copy(pixCopiaECola)}
            aria-label="Copiar código Pix"
          >
            {copied ? "Copiado!" : "Copiar"}
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default PixValueSection;
